import { fabric } from 'fabric';

const Line = fabric.util.createClass(fabric.Path, {
  type: 'line',

  initialize(element, options) {
    options || (options = {});
    this.callSuper('initialize', element, options);

    // Set default options
    this.set({
      objectCaching: false,
      hasBorders: false,
      hasControls: false,
      fill: 'transparent',
    });
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      customProps: this.customProps,
    });
  },
});

export default Line;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items/Line.js